export const FormatTimeInLocalTimezone = {
  options: {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  },

  mounted() {
    this.replaceTextWithFormattedDate(this.el);
  },

  updated() {
    this.replaceTextWithFormattedDate(this.el);
  },

  replaceTextWithFormattedDate(element) {
    const options = this.options;
    if ('includeSeconds' in element.dataset) {
      options.second = "numeric";
    }

    element.textContent = new Date(element.dataset.timestamp).toLocaleString(undefined, options);
  }
};
